<template>
  <CustomModal
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :visible-sections="{
      header: true,
      body: true,
      footer: false,
    }"
    :section-classes="{
      header: '!py-[10px]',
      body: '!px-4 !pb-6 !pt-0',
    }"
    :show-dividers="false"
    width="300px"
  >
    <template #default>
      <div class="flex flex-col gap-4 items-center justify-center">
        <span
          class="proxima_nova text-center text_color text-2xl font-bold leading-[30px]"
          >Scan To Download App</span
        >
        <span
          class="text-center px-5 text_color text-base font-light leading-[19px]"
          >Get the <b class="font-bold">SuperAGI Mobile App</b> on Android or
          iOS device today!</span
        >
      </div>
      <div class="py-8 flex justify-center items-center">
        <ThemeImage
          class="size-[200px] rounded-2xl"
          :icon="imageNames.APP_QR"
          alt="app_qr"
        />
      </div>
      <div class="flex gap-4 items-center justify-center flex-wrap">
        <a :href="mobileAppInfo.storeLinks.ios" target="_blank">
          <ThemeImage
            class="w-[121px] h-[39px]"
            :icon="imageNames.DOWNLOAD_FROM_APP_STORE"
            alt="download_from_app_store"
          />
        </a>
        <a :href="mobileAppInfo.storeLinks.android" target="_blank">
          <ThemeImage
            class="w-[121px] h-[39px]"
            :icon="imageNames.DOWNLOAD_FROM_GOOGLE_PLAY"
            alt="download_from_google_play"
          />
        </a>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from "@/src/components/CustomModal.vue";

import { mobileAppInfo } from "@/src/constants/appConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  visible: { type: Boolean, required: true },
});

const emits = defineEmits(["update:visible"]);
</script>
